import Utils from 'src/utils';
import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import communicate from 'src/api/communicate';

const REQUEST_SUB_TYPES = 'RequestSubTypes';
export const SAVE = 'SAVE_REQUEST_SUB_TYPES';
export const CREATE = 'CREATE_REQUEST_SUB_TYPE';
export const UPDATE = 'UPDATE_REQUEST_SUB_TYPE';
export const DELETE = 'DELETE_REQUEST_SUB_TYPE';

const saveRequestSubTypesList = (list) => ({ type: SAVE, payload: list });
const createRequestSubType = (entry) => ({ type: CREATE, payload: entry });
const updateRequestSubType = (entry) => ({ type: UPDATE, payload: entry });
const deleteRequestSubType = (entryId) => ({ type: DELETE, payload: entryId });

export function getRequestSubTypesAction(reqParams) {
  return (dispatch) => communicate({
    url: REQUEST_SUB_TYPES,
    method: 'get',
    getParams: Utils.objects.objectToQueryString(reqParams)
  })
    .then(({ data }) => data?.Data)
    .then((list = []) => {
      dispatch(saveRequestSubTypesList(list));
      return Promise.resolve(list);
    })
    .catch((error) => {
      toastrError(error);
      dispatch(saveRequestSubTypesList([]));
      return Promise.reject();
    });
}

export function createRequestSubTypeAction(payload) {
  return (dispatch) => communicate({
    url: REQUEST_SUB_TYPES,
    method: 'post',
    data: payload
  })
    .then(({ data }) => {
      toastrSuccess(data);
      return data?.Data;
    })
    .then((createdEntry) => {
      dispatch(createRequestSubType(createdEntry));
      return Promise.resolve(createdEntry);
    })
    .catch((error) => {
      toastrError(error);
      return Promise.reject();
    });
}

export function updateRequestSubTypeAction(payload) {
  return (dispatch) => communicate({
    url: REQUEST_SUB_TYPES,
    method: 'put',
    data: payload
  })
    .then(({ data }) => {
      toastrSuccess(data);
      return data?.Data;
    })
    .then((updatedEntry) => {
      dispatch(updateRequestSubType(updatedEntry));
      return Promise.resolve(updatedEntry);
    })
    .catch((error) => {
      toastrError(error);
      return Promise.reject();
    });
}

export function deleteRequestSubTypeAction(id) {
  return (dispatch) => communicate({
    url: REQUEST_SUB_TYPES,
    method: 'delete',
    getParams: Utils.objects.objectToQueryString({ id })
  })
    .then((response) => {
      dispatch(deleteRequestSubType(id));
      toastrSuccess(response);
      return Promise.resolve();
    })
    .catch((error) => {
      toastrError(error);
      return Promise.reject();
    });
}
